module.exports = __webpack_public_path__ + "static/media/Rectangle 59.19c74a81.png";